// extracted by mini-css-extract-plugin
module.exports = {"content":"Location_content__DT5OC","map":"Location_map__8F5nt","details":"Location_details__mP4Hu","left":"Location_left__WS-tY","right":"Location_right__7qcxl"};